import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { MapPin } from "lucide-react";

export function TerminalBreakdown({ customerId }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/terminals/breakdown", { params: customerId ? { customer_id: customerId } : {} }).then(({ data }) => setData(data)).catch(() => setData(null)); }, [customerId]);
  if (!data || !data.has_terminals) return null;
  return (
    <Card className="mb-6 overflow-hidden border-t-4 border-t-violet-600" data-testid="terminal-breakdown">
      <div className="px-4 sm:px-6 py-4 border-b bg-violet-50/60 flex items-center justify-between gap-3 flex-wrap">
        <div><div className="tag-mono text-violet-700">BY TERMINAL</div><h2 className="text-lg font-bold font-heading flex items-center gap-2"><MapPin className="h-4 w-4" />Drivers, units &amp; expirations per location</h2></div>
        <Link to="/company" className="text-sm font-medium text-violet-700 hover:underline" data-testid="terminal-breakdown-manage">Manage terminals →</Link>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs text-slate-500 bg-slate-50"><tr><th className="text-left px-4 sm:px-6 py-2">Terminal</th><th className="text-left px-3 py-2">Manager</th><th className="text-right px-3 py-2">Drivers</th><th className="text-right px-3 py-2">Units</th><th className="text-right px-3 py-2">Expiring ≤30d</th><th className="text-right px-3 py-2">Expired</th><th className="px-3 py-2" /></tr></thead>
          <tbody>
            {data.terminals.map((t) => (
              <tr key={t.id || "none"} className="border-t" data-testid={`terminal-row-${t.id || "none"}`}>
                <td className="px-4 sm:px-6 py-2 font-medium text-slate-900">{t.name}{t.city ? <span className="text-xs text-slate-500 font-normal"> · {t.city}{t.state ? `, ${t.state}` : ""}</span> : null}</td>
                <td className="px-3 py-2 text-slate-600">{t.manager_name || "—"}</td>
                <td className="px-3 py-2 text-right font-mono">{t.drivers}</td>
                <td className="px-3 py-2 text-right font-mono">{t.vehicles}</td>
                <td className={`px-3 py-2 text-right font-mono ${t.expiring ? "text-amber-700 font-semibold" : ""}`}>{t.expiring}</td>
                <td className={`px-3 py-2 text-right font-mono ${t.expired ? "text-rose-700 font-semibold" : ""}`}>{t.expired}</td>
                <td className="px-3 py-2 text-right whitespace-nowrap"><Link to={`/drivers?terminal=${t.id || "none"}${customerId ? `&customer=${customerId}` : ""}`} className="text-xs text-blue-700 hover:underline">Drivers →</Link> <Link to={`/fleet?terminal=${t.id || "none"}${customerId ? `&customer=${customerId}` : ""}`} className="text-xs text-blue-700 hover:underline ml-2">Units →</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
